import React, { useContext } from 'react'
import styled from 'styled-components'
import { FPS } from '../../../constants'
import CreationToolSourceEditor from '../../../types/source-editor'
import ArtboardComponent from '../../artboard'
import { CreationSourceEditorContext } from '../manager'
import Captions from './captions'
import Crop from './crop'
import Watermark from './watermark'

const Artboard = styled(ArtboardComponent)`
    height: 100% !important;
    left: 0;
    position: absolute;
    top: 0;
    width: 100% !important;
`

type Props = {
    height: number
    width: number
}

const CreationToolsSourceEditorArtboard = ({ width, height }: Props) => {
    const { source, artboardRef, currentEditor, crop } = useContext(CreationSourceEditorContext)
    const canvasScale = source.width / width
    const isCropping = currentEditor === CreationToolSourceEditor.Crop

    return (
        <Artboard
            {...{
                fps: FPS,
                ref: artboardRef,
                crop,
                canvasScale,
                height,
                width,
            }}
        >
            <Captions canvasScale={canvasScale} />
            <Watermark canvasScale={canvasScale} />
            {isCropping && <Crop canvasScale={canvasScale} />}
        </Artboard>
    )
}

export default CreationToolsSourceEditorArtboard
